<template>
  <div>
    <div class="min-vh">
      <CRow class="no-gutters px-3 px-sm-0">
        <b-col xl="4" class="text-center text-sm-left mb-3 mb-sm-0">
          <h1 class="mr-sm-4 header-main text-uppercase">SETTING WIDGET</h1>
        </b-col>
      </CRow>
      <!-- <div class="mt-3 bg-white-border p-3">
        <b-row class="no-gutters my-3">
          <b-col> Brand Logo </b-col>
          <b-col class="">
            <div class="image-panel">
              <div
                class="panel-bg-file-img mr-1 mb-1"
                v-bind:style="{
                  backgroundImage: 'url(' + form.imageUrl + ')',
                }"
              >
                <img
                  src="/img/loading.svg"
                  class="loading"
                  alt="loading"
                  v-if="isLoadingImage"
                />
              </div>
            </div>
          </b-col>
        </b-row>

        <b-row class="no-gutters my-3">
          <b-col class="my-auto"> Color </b-col>
          <b-col class="">
            <color-picker
              v-model="form.color"
              :position="{ left: 0, top: '40px' }"
            >
            </color-picker>
          </b-col>
        </b-row>
        <b-row class="no-gutters my-3">
          <b-col class="my-auto"> Header Style </b-col>
          <b-col class="">
            <b-form-group label="" v-slot="{ ariaDescribedby }">
              <b-form-radio-group
                id="radio-group-2"
                v-model="selected"
                :aria-describedby="ariaDescribedby"
                name="radio-sub-component"
              >
                <b-form-radio value="first">Solid</b-form-radio>
                <b-form-radio value="second">Gradient</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="no-gutters my-3">
          <b-col class="my-auto">Background </b-col>
          <b-col class="d-flex">
            <div
              v-for="(item, index) in form.backgroundList"
              :key="index"
              class="px-2"
            >
              <color-picker
                v-model="item.color"
                :position="{ left: 0, top: '40px' }"
                class="custom-color-picker"
              >
              </color-picker>
            </div>
          </b-col>
        </b-row>
        <b-row class="no-gutters my-3">
          <b-col class="my-auto">Size </b-col>
          <b-col class="">
            <b-form-group label="" v-slot="{ ariaDescribedby }">
              <b-form-radio-group
                id="radio-group-2"
                v-model="selected"
                :aria-describedby="ariaDescribedby"
                name="radio-sub-component"
              >
                <b-form-radio value="first">Default</b-form-radio>
                <b-form-radio value="second">Compact</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="no-gutters my-3">
          <b-col class="my-auto">Show typing indicator </b-col>
          <b-col class="">
            <toggle-button
              class="mt-1 mr-2"
              :color="{
                checked: '#27BDA7',
                unchecked: '#F1F1F1',
                disabled: '#CCCCCC',
              }"
            />
          </b-col>
        </b-row>
        <b-row class="no-gutters my-3">
          <b-col class="my-auto">Messenger Visibility </b-col>
          <b-col class="">
            <InputSelect
              title=""
              name="IntentType"
              isRequired
              v-model="form.visibilityId"
              :options="optionList"
              valueField="id"
              textField="name"
            />
          </b-col>
        </b-row>
        <b-row class="mt-5 mb-2">
          <b-col class="text-sm-right">
            <button
              type="button"
              class="btn btn-main btn-details-set ml-md-2 text-uppercase"
            >
              SAVE
            </button>
          </b-col>
        </b-row>
      </div> -->
    </div>
  </div>
</template>

<script>
import InputSelect from "@/components/inputs/InputSelect";
export default {
  components: {
    InputSelect,
  },
  data() {
    return {
      form: {
        color: "#ff9800",
        imageUrl: "",
        visibilityId: 0,
        backgroundList: [
          {
            id: 0,
            color: "#ffffff",
          },
          {
            id: 1,
            color: "#ffffff",
          },
          {
            id: 2,
            color: "#ffffff",
          },
          {
            id: 3,
            color: "#ffffff",
          },
          {
            id: 4,
            color: "#ffffff",
          },
          {
            id: 5,
            color: "#ffffff",
          },
        ],
      },
      isLoadingImage: false,
      optionList: [
        {
          id: 0,
          name: "Always Visible",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
::v-deep .color-block {
  border-radius: 5px;
  background-color: rgb(255, 255, 255);
  border: 1px solid #bebebe;
  width: 50px;
}

::v-deep .color-block .value {
  border-radius: 5px;
}
.panel-bg-file-img {
  width: 100%;
  padding-bottom: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  align-items: center;
  border: 2px dashed #bfbfbf;
  margin-bottom: 15px;
  position: relative;
}
.image-panel {
  width: 100px;
  height: 100px;
}
</style>